var _style, _rect, _rect2, _rect3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagOfSlovakia(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 900 600",
    style: {
      enableBackground: "new 0 0 900 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EE1C25;}\r\n\t.st1{fill:#0B4EA2;}\r\n\t.st2{fill:#FFFFFF;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Flag of Slovakia") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 900,
    height: 600
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st1",
    width: 900,
    height: 400
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st2",
    width: 900,
    height: 200
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_",
    className: "st2",
    d: "M393.479,141h-8.103H269.917H154.461h-8.103l-0.847,8.059 c-0.184,1.752-4.511,43.971-4.511,136.69c0,43.563,14.726,81.996,43.77,114.23c20.349,22.585,46.923,41.599,81.242,58.129 l3.905,1.881l3.906-1.881c34.32-16.53,60.896-35.544,81.246-58.129c29.044-32.234,43.771-70.667,43.771-114.23 c0-92.718-4.328-134.938-4.512-136.69L393.479,141L393.479,141z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M269.917,450C220.577,426.234,150,379.062,150,285.749C150,192.436,154.461,150,154.461,150h115.456h115.459 c0,0,4.463,42.437,4.463,135.749C389.839,379.062,319.261,426.234,269.917,450L269.917,450z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M280.484,261.284c13.36,0.216,39.425,0.739,62.635-7.027c0,0-0.613,8.306-0.613,17.98 c0,9.677,0.613,17.982,0.613,17.982c-21.289-7.125-47.58-7.273-62.635-7.082v51.539H259.38v-51.539 c-15.055-0.191-41.345-0.043-62.635,7.082c0,0,0.613-8.305,0.613-17.982c0-9.675-0.613-17.98-0.613-17.98 c23.21,7.766,49.275,7.243,62.635,7.027v-32.368c-12.177-0.108-29.723,0.473-49.563,7.113c0,0,0.613-8.305,0.613-17.982 c0-9.676-0.613-17.981-0.613-17.981c19.81,6.628,37.336,7.219,49.509,7.114c-0.626-20.498-6.597-46.332-6.597-46.332 s12.289,0.959,17.202,0.959c4.918,0,17.203-0.959,17.203-0.959s-5.969,25.835-6.596,46.33c12.174,0.106,29.699-0.485,49.509-7.114 c0,0-0.613,8.305-0.613,17.981c0,9.677,0.613,17.982,0.613,17.982c-19.839-6.639-37.386-7.221-49.563-7.113v32.368L280.484,261.284 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M269.904,329.094c-24.852,0-38.163,34.469-38.163,34.469s-7.385-16.344-27.661-16.344 c-13.719,0-23.829,12.201-30.256,23.5c24.959,39.705,64.78,64.207,96.079,79.281c31.305-15.075,71.152-39.571,96.112-79.281 c-6.427-11.299-16.537-23.5-30.256-23.5c-20.277,0-27.693,16.344-27.693,16.344S294.758,329.094,269.904,329.094L269.904,329.094z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagOfSlovakia);
export default __webpack_public_path__ + "static/media/Flag_of_Slovakia.b2a4dc3dc1b08c488987d5c83c6dd7b2.svg";
export { ForwardRef as ReactComponent };